import React, { useMemo } from 'react';
import { COLUMN_CLASSNAME_MAP } from 'src/app/Orders/order.const';

const NewOrderLoaderRow = ({ headCells }: any) => {
    const tableCells = useMemo(
        () => [
            {
                key: 'checkbox',
                htmlDynamic: (
                    <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip">
                        <div className="table-col-tooltip-space-common-xs flex items-center h-full">
                            <div className="custom-loading w-4 h-4 rounded flex-none" />
                        </div>
                    </td>
                ),
            },
            {
                key: 'orderId',
                htmlDynamic: (
                    <td className={COLUMN_CLASSNAME_MAP.orderId}>
                        <div className="flex gap-2 items-center">
                            <div className="flex items-center">
                                <div className="text-grayLight900 font-medium custom-loading">Lorem Ipsum dolor sit am</div>
                            </div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'salesRep',
                htmlDynamic: (
                    <td className="min-w-[150px] max-w-[150px] w-[150px]">
                        <div className="flex items-center gap-x-2">
                            <div className="custom-loading">lorem lorem lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'orderStatus',
                htmlDynamic: (
                    <td className="min-w-[125px] max-w-[125px] w-[125px]">
                        <div className="flex items-center">
                            <div className="custom-loading rounded-md">Dispatched</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'orderType',
                htmlDynamic: (
                    <td className="min-w-[100px] max-w-[100px] w-[100px]">
                        <div className="flex items-center">
                            <div className="custom-loading rounded-md">Lorem ipsu</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'shipperFullAddress',
                htmlDynamic: (
                    <td className="min-w-[165px]">
                        <div className="flex items-center">
                            <div className="custom-loading">lorem lorem lorem lorem lor</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'consigneeFullAddress',
                htmlDynamic: (
                    <td className="min-w-[165px]">
                        <div className="flex items-center">
                            <div className="custom-loading">lorem lorem lorem lorem lor</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'createdAt',
                htmlDynamic: (
                    <td className="min-w-[165px] w-[165px] max-w-[165px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem Ipsum dolor sit</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'updatedAt',
                htmlDynamic: (
                    <td className="min-w-[165px] w-[165px] max-w-[165px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem Ipsum dolor sit</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'handlingUnits',
                htmlDynamic: (
                    <td className="min-w-[155px] w-[155px] max-w-[155px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem Ipsum d</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'totalWeight',
                htmlDynamic: (
                    <td className="min-w-[140px] w-[140px] max-w-[140px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem Ipsum d</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'totalCost',
                htmlDynamic: (
                    <td className="min-w-[135px] w-[135px] max-w-[135px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem Ipsum d</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'pickupDate',
                htmlDynamic: (
                    <td className="min-w-[155px] w-[155px] max-w-[155px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Jan 1st, 2025</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'deliveryDate',
                htmlDynamic: (
                    <td className="min-w-[155px] w-[155px] max-w-[155px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Jan 1st, 2025</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'carrier',
                htmlDynamic: (
                    <td className="min-w-[190px] max-w-[190px]">
                        <div className="flex items-center gap-x-2">
                            <div className="custom-loading">Carrier Name lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'bolNumber',
                htmlDynamic: (
                    <td className="min-w-[145px] w-[145px] max-w-[145px]">
                        <div className="flex items-center">
                            <div className="custom-loading">BOL-12345</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'refNumber',
                htmlDynamic: (
                    <td className="min-w-[145px] w-[145px] max-w-[145px]">
                        <div className="flex items-center">
                            <div className="custom-loading">REF-12345</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'linearFootage',
                htmlDynamic: (
                    <td className="min-w-[130px] w-[130px] max-w-[130px]">
                        <div className="flex items-center">
                            <div className="custom-loading">12 Ft</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'equipmentType',
                htmlDynamic: (
                    <td className="min-w-[145px] w-[145px] max-w-[145px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Dry Van</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'action',
                htmlDynamic: (
                    <td className="min-w-[38px] max-w-[38px] w-[38px] table-cell-with-tooltip sticky right-0 bg-inherit z-[1]">
                        <div className="justify-end items-center gap-2 flex h-full table-col-tooltip-space-common-xs">
                            <span className="custom-loading">Lo</span>
                        </div>
                    </td>
                ),
            },
        ],
        [headCells]
    );

    if (!headCells || headCells.length === 0) {
        return (
            <>
                {tableCells.map((cell) => (
                    <React.Fragment key={cell.key}>{cell.htmlDynamic}</React.Fragment>
                ))}
            </>
        );
    }

    return (
        <>
            {headCells
                ?.filter((cell: any) => cell.visible)
                .map((cell: any) => {
                    const matched = tableCells.find((tCell) => tCell.key === cell.id);

                    if (!matched) return null;

                    return <React.Fragment key={cell.id}>{matched.htmlDynamic}</React.Fragment>;
                })}
        </>
    );
};

export default NewOrderLoaderRow;
